import { EventEmitter } from '@angular/core';
var DateComponent = /** @class */ (function () {
    function DateComponent() {
        this.months = ['Enero', 'Febrero', 'Marzo', 'Abril',
            'Mayo', 'Junio', 'Julio', 'Agosto',
            'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        this.years = [];
        // Fecha tope (fin del día) ya convertida a Date. Null = sin tope, que es el
        // comportamiento de siempre para las pantallas que no informan "maxDate".
        this.maxDateValue = null;
        this.selected = new EventEmitter();
        this.chargedYears();
    }
    Object.defineProperty(DateComponent.prototype, "maxDate", {
        /**
         * Fecha máxima seleccionable en formato 'dd-MM-yyyy'. Deshabilita los días y
         * meses posteriores y recorta la lista de años.
         */
        set: function (value) {
            this.maxDateValue = this.parseMaxDate(value);
            this.chargedYears();
            if (undefined !== this.month) {
                this.showCalendar();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateComponent.prototype, "value", {
        set: function (value) {
            var converted = null;
            if ((undefined === value) || (null === value)) {
                converted = new Date();
            }
            else {
                var pattern = /(\d{2})\-(\d{2})\-(\d{4})/;
                converted = new Date(value.replace(pattern, '$3-$2-$1'));
                this.chargedYears();
            }
            this.date = converted;
            this.month = converted.getMonth();
            this.year = converted.getFullYear();
            this.showCalendar();
        },
        enumerable: true,
        configurable: true
    });
    DateComponent.prototype.chargedYears = function () {
        var converted = null;
        var temp = new Date();
        this.currentMonth = temp.getMonth();
        this.currentDay = temp.getDate();
        if (!this.minYear) {
            this.currentYear = temp.getFullYear();
            this.years = [];
        }
        else {
            var pattern = /(\d{2})\-(\d{2})\-(\d{4})/;
            converted = new Date(this.minYear.replace(pattern, '$3-$2-$1'));
            this.currentYear = converted.getFullYear();
            this.years = [];
        }
        var startYear = this.currentYear - 10;
        this.min = startYear;
        while (startYear <= (this.currentYear + 10)) {
            this.years.push(startYear);
            startYear = startYear + 1;
        }
        this.max = startYear - 1;
        // El tope se aplica aquí y no solo al pintar los días porque "this.max" es
        // lo que frena la navegación por meses, y el selector de año ofrece +10
        // años por defecto: sin recortarlo se podría llegar al futuro por ahí.
        if (null !== this.maxDateValue) {
            var maxYear_1 = this.maxDateValue.getFullYear();
            if (this.max > maxYear_1) {
                this.max = maxYear_1;
            }
            this.years = this.years.filter(function (year) { return year <= maxYear_1; });
        }
    };
    /**
     * Convierte la fecha tope a Date situada al FINAL del día: la propia fecha
     * máxima tiene que seguir siendo seleccionable.
     */
    DateComponent.prototype.parseMaxDate = function (value) {
        if ((undefined === value) || (null === value) || ('' === value)) {
            return null;
        }
        var pattern = /(\d{2})\-(\d{2})\-(\d{4})/;
        var converted = new Date(value.replace(pattern, '$3-$2-$1'));
        if (isNaN(converted.getTime())) {
            return null;
        }
        converted.setHours(23, 59, 59, 999);
        return converted;
    };
    DateComponent.prototype.isDisabled = function (day) {
        return (null !== this.maxDateValue) && (day.date.getTime() > this.maxDateValue.getTime());
    };
    DateComponent.prototype.isMonthDisabled = function (month) {
        return this.isMonthAfterMax(this.year, month);
    };
    DateComponent.prototype.isMonthAfterMax = function (year, month) {
        if (null === this.maxDateValue) {
            return false;
        }
        return new Date(year, month, 1).getTime() > this.maxDateValue.getTime();
    };
    DateComponent.prototype.onShowMonth = function () {
        this.showingYear = false;
        this.showingMonth = !this.showingMonth;
    };
    DateComponent.prototype.onShowYear = function () {
        this.showingMonth = false;
        this.showingYear = !this.showingYear;
    };
    DateComponent.prototype.onPreviousMonth = function () {
        this.date.setMonth(this.date.getMonth() - 1);
        if (this.date.getFullYear() < this.min) {
            this.date.setMonth(this.date.getMonth() + 1);
            return;
        }
        this.month = this.date.getMonth();
        this.year = this.date.getFullYear();
        this.selected.emit(this.date);
        this.showCalendar();
    };
    DateComponent.prototype.onNextMonth = function () {
        this.date.setMonth(this.date.getMonth() + 1);
        // El control por año no basta cuando el tope cae a mitad de año: hay que
        // comparar también el mes al que se salta contra la fecha máxima.
        if ((this.date.getFullYear() > this.max)
            || this.isMonthAfterMax(this.date.getFullYear(), this.date.getMonth())) {
            this.date.setMonth(this.date.getMonth() - 1);
            return;
        }
        this.month = this.date.getMonth();
        this.year = this.date.getFullYear();
        this.selected.emit(this.date);
        this.showCalendar();
    };
    DateComponent.prototype.monthName = function () {
        return this.months[this.month];
    };
    DateComponent.prototype.onSetMonth = function (value) {
        if (this.isMonthDisabled(value)) {
            return;
        }
        this.date.setMonth(value);
        this.month = this.date.getMonth();
        this.year = this.date.getFullYear();
        this.selected.emit(this.date);
        this.showingMonth = false;
        this.showCalendar();
    };
    DateComponent.prototype.onSetYear = function (value) {
        this.date.setFullYear(value);
        this.year = this.date.getFullYear();
        this.selected.emit(this.date);
        this.showingYear = false;
        this.showCalendar();
    };
    DateComponent.prototype.onSetNow = function () {
        // El botón "Hoy" es otra vía para fijar fecha: si el tope fuese anterior a
        // hoy también tiene que respetarlo.
        if ((null !== this.maxDateValue) && (Date.now() > this.maxDateValue.getTime())) {
            return;
        }
        this.date = new Date();
        this.year = this.date.getFullYear();
        this.month = this.date.getMonth();
        this.selected.emit(this.date);
        this.showingMonth = false;
        this.showingYear = false;
        this.showCalendar();
    };
    DateComponent.prototype.onSetDate = function (day) {
        // Los días por encima del tope se pintan deshabilitados; aquí se corta
        // también el click para que el estilo no sea la única barrera.
        if (this.isDisabled(day)) {
            return;
        }
        this.date = day.date;
        this.year = this.date.getFullYear();
        this.month = this.date.getMonth();
        this.selected.emit(this.date);
        this.showingMonth = false;
        this.showingYear = false;
        this.showCalendar();
    };
    DateComponent.prototype.showCalendar = function () {
        var temp = new Date();
        var newCalendar = [];
        var i;
        temp.setDate(1);
        temp.setMonth(this.month);
        temp.setFullYear(this.year);
        var pn = temp.getDay() === 0 ? 7 : temp.getDay();
        for (i = 1; i < pn; i++) {
            var prevDay = new Date(temp);
            prevDay.setDate(prevDay.getDate() - i);
            var dayToAdd = {
                day: prevDay.getDate(),
                month: prevDay.getMonth(),
                year: prevDay.getFullYear(),
                date: prevDay
            };
            newCalendar.push(dayToAdd);
        }
        newCalendar.reverse();
        var monthDay = new Date(temp);
        while (monthDay.getMonth() === temp.getMonth()) {
            var dayToAdd = {
                day: monthDay.getDate(),
                month: monthDay.getMonth(),
                year: monthDay.getFullYear(),
                date: new Date(monthDay)
            };
            newCalendar.push(dayToAdd);
            monthDay.setDate(monthDay.getDate() + 1);
        }
        temp.setMonth(temp.getMonth() + 1);
        temp.setDate(temp.getDate() - 1);
        var nn = 7 - temp.getDay();
        for (i = 0; i < nn; i++) {
            var nextDay = new Date(temp);
            nextDay.setDate(nextDay.getDate() + i + 1);
            var dayToAdd = {
                day: nextDay.getDate(),
                month: nextDay.getMonth(),
                year: nextDay.getFullYear(),
                date: nextDay
            };
            newCalendar.push(dayToAdd);
        }
        this.calendarDays = newCalendar;
    };
    return DateComponent;
}());
export { DateComponent };
